export const SOURCE_TYPES = {
  direct: 'website',
  google: 'google'
};
